<template>
  <v-dialog
    v-model="show"
    :persistent="options.persistent"
    :transition="transition"
    :max-width="options.maxWidth"
    min-width="640px"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    scrollable
    class="search-dialog"
  >
    <v-card height="340px">

      <v-toolbar
        flat
        dark
        color="primary"
      >
        <v-toolbar-title>User Group Creation</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          icon
          dark
          @click="cancelDialog"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <!-- TODO: -->
        <!-- User group name field (REQUIRED) -->
        <v-form v-model="valid">
          <v-layout
            row
            class="mb-4"
          >
            <v-text-field
              box
              outline
              hide-details
              :label="userGroupNameLabel"
              v-model="userGroupName"
              :rules="userGroupRule"
              required
            ></v-text-field>
          </v-layout>

          <!-- TODO: -->
          <!-- Optional field, Provider ID/NPI -->
          <v-layout column>
            <provider-search-field
              @selectedProvider="selectProvider"
              ref="provSearchField"
            >
            </provider-search-field>
            <v-layout class="provider-error ml-2">
              {{ providerError }}
            </v-layout>
          </v-layout>
        </v-form>

        <!-- Submit button -->
        <v-layout
          row
          class="mb-3"
        >
          <v-spacer></v-spacer>
        </v-layout>
      </v-card-text>

      <v-spacer />

      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          depressed
          @click="submit"
          :disabled="providerError || !valid"
        >Submit</v-btn>

      </v-card-actions>
    </v-card>

  </v-dialog>
</template>


<script>
import bus from '@/core/helpers/bus'
import DialogMixin from '@/core/mixins/DialogMixin'
import { mapActions } from 'vuex'
import ProviderSearchField from '@/components/providerSearchField'

export default {
  mixins: [DialogMixin],
  components: {
    ProviderSearchField
  },
  data() {
    return {
      // User-group name
      userGroupName: null,
      userGroupNameLabel: 'User Group Name',
      userGroupRule: [v => !!v || 'A name is required for a user-group'],

      // Provider info
      providerIDForSubmission: null,
      providerError: null,

      // Form
      valid: false
    }
  },
  methods: {
    ...mapActions('admin', ['submitUserGroup']),
    submit() {
      const vm = this
      vm.submitUserGroup({
        name: vm.userGroupName,
        provider: vm.providerIDForSubmission
      }).then(() => {
        vm.toast('success', 'User group successfully created')
      })

      vm.userGroupName = null
      vm.providerIDForSubmission = null
      vm.$refs.provSearchField.clearSearch()

      vm.ok()
    },
    selectProvider(provider) {
      if (provider.userGroup) {
        this.providerError =
          'This provider already has a user group: ' + provider.userGroup
      } else {
        this.providerIDForSubmission = provider._id
      }
    },
    toast(type, text) {
      bus.$emit('toast', { type, text })
    },
    cancelDialog() {
      // TODO: Clear the states
      this.cancel()
    }
  },
  watch: {
    providerIDForSubmission() {
      this.providerError = null
    }
  },
  mounted() {
    this.$on('open', this.onOpen)
    this.$on('close', this.onClose)
  }
}
</script>


<style lang="scss" scoped>
@import '../../../styles/form';

.usergroup-dialog {
  min-height: 640px;
  height: 100px;
}

.provider-error {
  color: red;
  font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/components/dialogs/NewUserGroupDialog.vue